import { JobTitleEnum } from '@pflegia/types/api/job-title';
import { GEHALT } from '@pflegia/ui/pflegia/constants/routes';
import { normalizeJobsParams } from '@pflegia/util/common/normalize-jobs-params';

import { GERMANY_SLUG, WEITERBILDUNGEN_POSITION_DEFINITIONS } from '../../weiterbildungen/utils/weiterbildungen.constants';
import { LlpFaqData } from './select-llp-faqs';

const FURTHER_EDUCATION_PATH_BY_JOB_TITLE: Partial<Record<JobTitleEnum, string>> = Object.fromEntries(
  Object.values(WEITERBILDUNGEN_POSITION_DEFINITIONS)
    .filter(definition => definition.furtherEducationPath)
    .map(definition => [definition.jobTitle.title, definition.furtherEducationPath]),
);

export const buildLlpFaqLinks = ({
  translatedJobTitle,
  location,
  jobTitleKey,
  isPraxia,
}: {
  isPraxia?: boolean;
  jobTitleKey?: JobTitleEnum;
  location?: string;
  translatedJobTitle?: string;
}): NonNullable<LlpFaqData['links']> => ({
  salary:
    !isPraxia && translatedJobTitle
      ? `${GEHALT}/${normalizeJobsParams(translatedJobTitle)}/${location ? normalizeJobsParams(location) : GERMANY_SLUG}`
      : undefined,
  furtherEducation: jobTitleKey ? FURTHER_EDUCATION_PATH_BY_JOB_TITLE[jobTitleKey] : undefined,
});
